import Toast from './Toast'
import './Toast.css'

const ToastContainer = ({ toasts, position = 'bottom', hideToast }) => {
    const getToastContainerClass = () => {
        switch (position) {
            case 'top':
                return 'top-position'
            case 'right':
                return 'right-position'
            case 'left':
                return 'left-position'

            default:
                return 'bottom-position'
        }
    }

    return (
        <div className={getToastContainerClass()}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    id={toast.id}
                    title={toast.title}
                    message={toast.message}
                    type={toast.type}
                    hideToast={hideToast}
                />
            ))}
        </div>
    )
}

export default ToastContainer
